module.exports = __webpack_public_path__ + "img/c.408e69fb.jpg";